// A single, short notification per fresh event. Browsers require a prior gesture
// before AudioContext can play; the caller deliberately does not replay it later.
const profiles = {
  LOW: { notes: [520], duration: 0.16, type: "sine" },
  MEDIUM: { notes: [660], duration: 0.2, type: "triangle" },
  NORMAL: { notes: [660], duration: 0.2, type: "triangle" },
  HIGH: { notes: [880, 660], duration: 0.12, type: "square" },
  CRITICAL: { notes: [980, 740], duration: 0.17, type: "square" },
};

export const playAlertSound = (severity, volume, AudioContextClass = window.AudioContext || window.webkitAudioContext) => {
  if (!AudioContextClass || !Number.isFinite(volume) || volume <= 0) return false;
  const profile = profiles[String(severity || "HIGH").toUpperCase()] || profiles.HIGH;
  try {
    const context = new AudioContextClass();
    profile.notes.forEach((frequency, index) => {
      const start = context.currentTime + index * (profile.duration + 0.045);
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = profile.type;
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0.001, start);
      gain.gain.linearRampToValueAtTime(Math.min(0.15, volume / 100 * 0.15), start + 0.018);
      gain.gain.exponentialRampToValueAtTime(0.001, start + profile.duration);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + profile.duration + 0.01);
    });
    const totalMs = (profile.notes.length * (profile.duration + 0.045) + 0.1) * 1000;
    setTimeout(() => context.close?.().catch?.(() => {}), totalMs);
    return true;
  } catch { return false; }
};
